import { render, staticRenderFns } from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=template&id=65a73a0a&scoped=true"
import script from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"
export * from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"
import style0 from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=style&index=0&id=65a73a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a73a0a",
  null
  
)

export default component.exports